import { getPlayerThickIcon } from "app/player/getPlayerThickIcon"
import PlayerIcon from "./PlayerIcon"
import PlayerIconButton from "./PlayerIconButton"
import { ComponentProps } from "react"

type Props = ComponentProps<typeof PlayerIconButton>

export default function PlayerFullScreenButton({
  color = "blue",
  ...props
}: Props) {
  return (
    <PlayerIconButton color={color} {...props}>
      <PlayerIcon
        src={getPlayerThickIcon(color ?? "blue", "ico_fullscreen.svg")}
        size={18}
      />
    </PlayerIconButton>
  )
}
